import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'jira',
  version: '1.6.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
